import React from 'react';

import type { Agent } from '@/hooks/useAgents';

import { getHealthCheckStatus } from './agentHealthUtils';
import { HealthCheckCard } from './HealthCheckCard';

interface HealthCheckBoxProps {
  agent: Agent;
}

export const HealthCheckBox: React.FC<HealthCheckBoxProps> = ({ agent }) => {
  const healthStatus = getHealthCheckStatus(agent);

  return (
    <div data-testid="agent-health-check">
      <div className="flex flex-col gap-2">
        <HealthCheckCard
          title="Nested Virtualization"
          status={
            healthStatus.nestedVirtualization.status as
              | 'success'
              | 'error'
              | 'unknown'
          }
          message={healthStatus.nestedVirtualization.message}
        />
        <HealthCheckCard
          title="Network Egress"
          status={
            healthStatus.networkEgress.status as 'success' | 'error' | 'unknown'
          }
          message={healthStatus.networkEgress.message}
        />
        <HealthCheckCard
          title="Disk Space"
          status={
            healthStatus.diskSpace.status as 'success' | 'error' | 'unknown'
          }
          message={healthStatus.diskSpace.message}
        />
        <HealthCheckCard
          title="RAM"
          status={healthStatus.ram.status as 'success' | 'error' | 'unknown'}
          message={healthStatus.ram.message}
        />
      </div>
    </div>
  );
};
